import AntibodySearchResults from "./AntibodySearchResults";
import { useState } from 'react';
import CollapsedIcon from '@material-ui/icons/ArrowRight';
import ExpandedIcon from '@material-ui/icons/ArrowDropDown';


const headingSize = 10;

export default function PopoverAntibodySpecification(){

  const [ open, setOpen ] = useState(false);

  const icon = open ? <ExpandedIcon/> : <CollapsedIcon style={{
    padding:0,
    margin:0,
  }}/>


  const fieldTitles = [
    {title:"Supplier",
      width:80
    },
    {title:"Cat"},
    {title:"Lot"},
  ]

  let fieldComponents = fieldTitles.map(({title,width}) => {

    let className = `${width?"flex-expand":""} rel`;

    return (
      <div style={{
        //display:'flex',
        borderRight:'1px solid #ccc',
      }} class={className}>

        <div style={{
          width:(width || 'unset'),
          fontSize:headingSize
        }}>
          {title}
        </div>
        <input style={{
          border:0,
          width:'100%'
        }}/>
      </div>
    )
  })

  let suppliers = [] || ["AbCam","CST","BioRad"];
  

  return ( 
    <div style={{

      padding:0, 
      background:'#eee',
      width:'100%',
      borderTop:'1px solid #ccc',
      position:'relative',
    }}>

      <div>
          {suppliers.map(name => {
            return (
              <div class="hoverable" style={{
                background:'white',
              }}>{name}</div>
            )
          })}
        </div>

      <div

    onClick={() => {
              setOpen(!open);
            }}
        class="rel">
        <div style={{
          textAlign:'center',
          //fontWeight:'bold',
        }}>
          <div 
            
          style={{
            position:'absolute',
            left:-5,
            top:'50%',
            transform:'translate(0,-50%)',
          }}>{icon}</div>
          Antibody Info
        </div>
      </div>

      {open && <div class="rel" style={{


        borderTop:'1px solid #ccc',
        display:'flex',
        //flexExpand
      }}>

        

        {fieldComponents}




      </div>}

      {false && <AntibodySearchResults/>}
    </div>
  )
}
